import { Props as ButtonWebProps } from '@rover/kibble/core/Button/Button';
import { ButtonSizes } from '@rover/kibble/core/Button/Button.common';
import { Props as ButtonNativeProps } from '@rover/kibble/core/Button/Button.native';

export type ButtonWithCountBadgeCommonProps = {
  badgeCount?: number;
  ariaLabel?: string;
  badgeTestID?: string;
  /**
   * When true, hides the count badge from the accessibility tree (iOS
   * accessibilityElementsHidden + Android importantForAccessibility). Defaults to false.
   * No effect on web.
   *
   * Only set this true when the count is announced some other way (e.g. included in the
   * button's ariaLabel). Otherwise the count becomes silent to screen readers — verify
   * with VoiceOver/TalkBack before enabling.
   */
  hideBadgeFromScreenReader?: boolean;
};

export const BUTTON_SIZE_TO_BADGE_SIZE_MAP: Record<ButtonSizes, number> = {
  small: 17,
  default: 24,
  large: 28,
};

export type ButtonWithCountBadgeNativeProps = ButtonWithCountBadgeCommonProps & ButtonNativeProps;

export type ButtonWithCountBadgeWebProps = ButtonWithCountBadgeCommonProps & ButtonWebProps;
